import React from "react";

export default class TCSummaryForm extends React.Component {
    constructor(props) {
        super(props);         
    }

    render() {
        const self = this;
        const summary = self.props.summary;

        return (
            <div className="container-fluid ap-border-color-lightgray ap-padding ap-top-margined">
                <div className="row">
                    <div className="col-md-6 col-sm-12">
                        Total regular hours:
                    </div>
                    <div className="col-md-6 col-sm-12">
                        {summary.totalRegular}
                    </div>
                </div>
                <div className="row ap-top-margined">
                    <div className="col-md-6 col-sm-12">
                        Total overtime hours:
                    </div>
                    <div className="col-md-6 col-sm-12">
                        {summary.totalOvertime}
                    </div>
                </div>
                <div className="row ap-top-margined">
                    <div className="col-md-6 col-sm-12">
                        Total doubletime hours:
                    </div>
                    <div className="col-md-6 col-sm-12">
                        {summary.totalDoubletime}
                    </div>
                </div>
                <div className="row ap-top-margined">
                    <div className="col-md-6 col-sm-12">
                        Total miscellaneous hours:
                    </div>
                    <div className="col-md-6 col-sm-12">
                        {summary.totalMisc}
                    </div>
                </div>                
            </div>
        );
    }
}